import { createApi } from '@reduxjs/toolkit/query/react';
import { backend_server_address } from '../../backendServer';
import { axiosBaseQuery } from '../../store/utility';

// Define a service using a base URL and expected endpoints
export const versionAPI = createApi({
    reducerPath: 'versionAPI',
    baseQuery: axiosBaseQuery({ baseUrl: backend_server_address + '/api/app_version/' }),
    tagTypes: ['Version'],
    endpoints: (builder) => ({
        getLatestAppVersion: builder.query({
            query: ({ app_name = 'maper-ui', version, build_date }) => ({
                url: 'latest/',
                method: 'GET',
                withCredentials: true,
                params: { app_name, version, build_date },
            }),
            providesTags: (result) => {
                return result ? ['Version'] : ['Version'];
            },
        }),
        getMinimumAppBuild: builder.query({
            query: () => ({ url: 'minimum/', method: 'GET' }),
        }),
    }),
});

export const { useGetLatestAppVersionQuery, useGetMinimumAppBuildQuery } = versionAPI;
export const versionAPIReducer = versionAPI.reducer;
export const versionAPIReducerPath = versionAPI.reducerPath;
export const versionAPIReducerMiddleware = versionAPI.middleware;
